<div
  class="flex flex-col md:flex-row py-4 content-center justify-between md:items-center gap-2"
>
  <div class="flex items-center gap-3">
    <span
      class="flex items-center justify-center w-12 h-12 rounded-xl shrink-0"
      style="
        background: var(--ds-surface-muted);
        border: 1px solid var(--ds-border-default);
      "
    >
      <span class="ds-heading-4">{{ greetingIcon() }}</span>
    </span>
    <div class="flex flex-col">
      <p class="ds-heading-3-semibold">{{ greeting() }}</p>
      <p class="ds-body-2" style="color: var(--ds-text-secondary)">
        {{ today() | date: 'fullDate' : '' : 'de' }}
      </p>
    </div>
  </div>
</div>
